import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Collapse, Grid, Grow, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { commonSort } from "../../common";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import AddButton from "../../components/AddButton/AddButton";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import AddEmailPopup from "../../components/Popup/AddEmailPopup";
import Modal from "../../components/Modal/Modal";
import { getMailGroups, addMailGroup, deleteMailGroup, updateMailGroup, addMailAddresses, deleteMailAddress } from "../../store/actions/MailGroupsActions";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

export default function MailGroups() {
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    let [rows, setRows] = useState([]);
    const [initialRows, setInitialRows] = useState([]);

    useEffect(() => {
        LoadHandler();
    }, []);

    const LoadHandler = () => {
        dispatch(getMailGroups());
    };

    const { MailGroups } = useSelector((state) => state);

    useEffect(() => {
        if (MailGroups?.mailGroupList?.resultObject) {
            setInitialRows(MailGroups.mailGroupList.resultObject);
            setRows(MailGroups.mailGroupList.resultObject);
            setEditable(false);
        }
    }, [MailGroups]);

    useEffect(() => {
        if (MailGroups?.isTaskUpdated) {
            setEditableRow(false);
            setDisableButton(false);
            LoadHandler();
        }
    }, [MailGroups.isTaskUpdated]);

    const updateAddHandler = (row) => {
        let data = {
            name: row.name,
            status: 1,
        };

        if (row.id != "") {
            // Update
            data["id"] = row.id;
            dispatch(updateMailGroup(data));
        } else {
            // Add
            dispatch(addMailGroup(data));
        }
    };

    const deleteHandler = (row) => {
        if (row.emailAddresses) {
            // Delete Mail Group
            dispatch(deleteMailGroup(row.id));
        } else {
            // Delete E-mail
            dispatch(deleteMailAddress(row.id));
        }

        toggleModal();
    };

    // Add Email Popup
    const [isEmailPopup, setIsEmailPopup] = useState(false);
    const [emailPopupRowId, setEmailPopupRowId] = useState(0);
    const [emailGroupName, setEmailGroupName] = useState(0);
    const handleEmailAdd = (data, relationData, emailList) => {
        
        data = data.map(({ id, errorText, ...rest }) => {
            return rest;
        });
        let email = [];
        data.map((item) => {
            email.push({
                name: item.name,
                email: item.mailAdress
        })});
        emailList.map((item) => {
            email.push({
                name: item.name,
                email: item.email
        })});
        let payload ={
            id: data[0].mailGroupId,
            payloadData: {
                emailAddresses: email,
                areaIds: relationData.areaGroupIds,
                maintenanceTypes: {
                    mailPeriod: relationData.mailPeriodId,
                    maintenanceTypeIds: relationData.maintenanceTypeIds
                }
            }

        }
        dispatch(addMailAddresses(payload));
        setIsEmailPopup(false);
    };

    const handleEmailOpen = (row) => {
        setEmailPopupRowId(row.id);
        setEmailGroupName(row.name);
        setIsEmailPopup(true);
    };

    const handleEmailCancel = () => {
        setIsEmailPopup(false);
    };

    // Expand row
    const [openRow, setOpenRow] = useState(false);
    const [expandID, setExpandId] = useState("");
    const expandRow = (rowId) => {
        if (openRow && expandID !== rowId) {
            setExpandId(rowId);
        } else {
            setOpenRow(!openRow);
            setExpandId(rowId);
        }
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (_event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setCurrentPage(0);
    };

    // Dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (row, column) => {
        const sortedList = commonSort(row, column);
        setSortOrder(sortedList[0]);
        setSortColumn(sortedList[1]);
        setInitialRows(sortedList[2]);
    };

    // Edit rows
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");
    const enableEditHandler = (row) => {
        if (editable) {
            filterData(filterText);
        }
        setEditableRow(row.id);
        setEditable(true);

        setError({
            nameText: "",
        });
    };

    const [disableButton, setDisableButton] = useState(false);
    const disableEditHandler = () => {
        filterData(filterText);
        setEditable(false);
        setDisableButton(false);

        setError({
            nameText: t("EmptyCheck"),
        });
    };

    // Set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }

        // Validation
        if (value.length > 0) {
            if (obj === "name") {
                setError({ ...error, nameText: "" });
            }
        } else {
            if (obj === "name") {
                setError({ ...error, nameText: t("EmptyCheck") });
            }
        }
    };

    // Add blank row for new mailgroup addition
    const addBlankRowHandler = () => {
        setDisableButton(true);
        setCurrentPage(0);
        const addedBlankRow = [
            {
                id: "",
                name: "",
                mailGroupAdresses: [],
            },
        ];

        const newRows = addedBlankRow.concat(rows);
        setRows(newRows);
        setEditableRow(newRows[0].id);
        setEditable(true);

        setError({ nameText: t("EmptyCheck") });
    };

    // Delete confirm popup
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState({});
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        const directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`ng_rowItems_TableCell_Actions_${index}_${item.id}`} align="center">
                        {t("Actions")}
                    </TableCell>
                );
            } else if (item.id === "") {
                return <TableCell id={`ng_rowItems_TableCell_Id_${index}_${item.id}`} align="center"></TableCell>;
            } else {
                return isSortingAction ? (
                    <TableCell id={`ng_rowItems_TableCell_${index}_${item.id}`} align="center">
                        <TableSortLabel
                            id={`ng_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => handleSort(cloneObject(initialRows), item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    // Filter table
    const [filterText, setFilterText] = useState("");
    const filterData = (value) => {
        const newFilteredText = value.toLowerCase();
        setFilterText(newFilteredText);
        let filteredItems = cloneObject(initialRows).filter((item) => item.id.toString().includes(newFilteredText) || item.name.toLowerCase().includes(newFilteredText));
        setRows(filteredItems);
    };

    useEffect(() => {
        filterData(filterText);
    }, [initialRows]);

    // Validation
    const [error, setError] = useState({
        nameText: t("EmptyCheck"),
    });
    const [isAddDisable, setIsAddDisable] = useState(true);

    useEffect(() => {
        if (error.nameText === "") {
            setIsAddDisable(false);
        } else {
            setIsAddDisable(true);
        }
    }, [error]);

    return (
        <StyledTableDiv>
            <h1>{t("MailGroups")}</h1>
            <AddButton onClick={() => addBlankRowHandler()} disabled={disableButton} />
            <Grid container spacing={4} alignItems="center" justifyContent="center" sx={{ marginBottom: 4 }}>
                <Grid item xs={12} sm={12} md={4}>
                    <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => filterData(value)} />
                </Grid>
            </Grid>
            <Box m={2} />
            {rows.length > 0 ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer id="ng_TableContainer" component={Paper}>
                        <Table id="ng_Table" aria-label="collapsible table">
                            <TableHead id="ng_TableHead">
                                <TableRow id="ng_TableRow">
                                    {renderTableCell(
                                        [
                                            { id: "", label: "" },
                                            { id: "id", label: t("ID") },
                                            { id: "name", label: t("Name") },
                                            { id: "Actions", label: t("Actions") },
                                        ],
                                        true
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody id="mg_TableBody">
                                {rows.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                                    <React.Fragment>
                                        <TableRow id={`ng_TableRow_1`} key={row.id}>
                                            <TableCell id={`mg_TableCell_expand`}>
                                                <IconButton aria-label="expand row" size="small" onClick={() => expandRow(row.id)}>
                                                    {openRow && expandID === row.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                </IconButton>
                                            </TableCell>
                                            <TableCell id={`mg_TableCell_id`} align="center" width="10%">
                                                {row.id}
                                            </TableCell>
                                            <TableCell id={`mg_TableCell_definition`} align="center" width="60%">
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        id="mg_TextField_definition"
                                                        onInput={(e) => setRowHandler(e.target.value, "name", row)}
                                                        defaultValue={row.name}
                                                        variant="outlined"
                                                        error={error.nameText.length > 0}
                                                        helperText={error.nameText}
                                                    />
                                                ) : (
                                                    row.name
                                                )}
                                            </TableCell>
                                            <TableButtons
                                                id={`mg_TableButtons_buttons`}
                                                width="30%"
                                                table={"NotificationGroup"}
                                                addDisabled={isAddDisable}
                                                editable={editable}
                                                editableRow={editableRow}
                                                row={row}
                                                updateAddHandler={() => updateAddHandler(row)}
                                                disableEditHandler={() => disableEditHandler()}
                                                enableEditHandler={() => enableEditHandler(row)}
                                                deleteButtonHandler={() => deleteButtonHandler(row)}
                                                openDetailPage={() => handleEmailOpen(row)}
                                                detail={true}
                                            />
                                        </TableRow>
                                        <TableRow>
                                            {expandID === row.id ? (
                                                <TableCell id={`mg_TableCell_4_subList`} colSpan={8}>
                                                    <Collapse id={`mg_Collapse_1_${rowIndex}`} in={openRow} timeout="auto" unmountOnExit>
                                                        <Box id={`mg_Box_1_${rowIndex}`} margin={1}>
                                                            <Typography id={`ng_Typography_1_${rowIndex}`} variant="h6" gutterBottom component="div">
                                                                {t("EmailList")}
                                                            </Typography>
                                                            <Table id={`ng_Table_1_${rowIndex}`} size="small">
                                                                <TableHead id={`ng_TableHead_1_${rowIndex}`}>
                                                                    <TableRow id={`ng_TableRow_2_${rowIndex}`}>
                                                                        {renderTableCell(
                                                                            [
                                                                                { id: "id", label: t("ID") },
                                                                                { id: "name", label: t("Name") },
                                                                                { id: "mailAdress", label: t("Email") },
                                                                                { id: "Actions", label: t("Actions") },
                                                                            ],
                                                                            false
                                                                        )}
                                                                    </TableRow>
                                                                </TableHead>
                                                                {row.emailAddresses ? (<TableBody id={`ng_TableBody_1_${rowIndex}`}>
                                                                    {row.emailAddresses.map((detailRow, itemIndex) => (
                                                                        <TableRow id={`ng_TableRow_3_${rowIndex}_${itemIndex}`} key={detailRow.id}>
                                                                            <TableCell id={`ng_TableCell_subId`} align="center">
                                                                                {detailRow.id}
                                                                            </TableCell>
                                                                            <TableCell id={`ng_TableCell_subDefinition`} align="center">
                                                                                {detailRow.name}
                                                                            </TableCell>
                                                                            <TableCell id={`ng_TableCell_subEmail`} align="center">
                                                                                {detailRow.email}
                                                                            </TableCell>
                                                                            <TableButtons
                                                                                id={`ng_TableButtons_subButtons`}
                                                                                deleteCheckItem={true}
                                                                                editable={false}
                                                                                row={detailRow}
                                                                                deleteHandlerCheckItem={() => deleteButtonHandler(detailRow)}
                                                                            />
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>) : null}
                                                            </Table>
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            ) : null}
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={currentPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}

            <Modal title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => deleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={toggleModal} />

            {isEmailPopup ? <AddEmailPopup open={isEmailPopup} mailGroupId={emailPopupRowId} mailGroupName={emailGroupName} rows={rows} onAdd={handleEmailAdd} onCancel={handleEmailCancel} /> : null}

            <LoadingBackdrop id="ng_LoadingBackdrop" />
        </StyledTableDiv>
    );
}
